import type { FAQEntry, LinkSegments } from '$lib/components/seo/types';
import type { AvailableLanguageTag } from '$paraglide/runtime';
import { getSegmentsLabel, segments2href, segments2route } from '$lib/components/seo/linkSegments';
import { i18nPath } from '$lib/i18n/routing';
import {
	getAddressSegmentsLabels,
	getAddressSegmentsLinks,
	replaceHtml,
	replaceText,
} from './format';

interface FillItineraryResultDataArgs {
	lang: AvailableLanguageTag;
	departureSegments: LinkSegments;
	arrivalSegments: LinkSegments;
	question: string;
	answer: string;
}

export function fillItineraryResultData({
	lang,
	answer,
	question,
	arrivalSegments,
	departureSegments,
}: FillItineraryResultDataArgs): FAQEntry {
	const departure = getSegmentsLabel(departureSegments);
	const arrival = getSegmentsLabel(arrivalSegments);

	const answerHtmlWithoutLinks = replaceText(
		answer,
		{
			itineraryUrl: segments2route(departureSegments, arrivalSegments, lang),
			hotelsUrl: segments2href(arrivalSegments, lang, ['map', 'ACCOMMODATION']),
			departure,
			arrival,
			levelAreaLabelsForArrival: getAddressSegmentsLabels(arrivalSegments),
			levelAreaLabelsForDeparture: getAddressSegmentsLabels(departureSegments),
		},
		false,
	);

	const answerHtml = replaceHtml(answerHtmlWithoutLinks, {
		levelAreaLinksForArrival: getAddressSegmentsLinks(arrivalSegments, lang),
		levelAreaLinksForDeparture: getAddressSegmentsLinks(departureSegments, lang),
	});

	return {
		question: replaceText(question, {
			departure,
			arrival,
		}),
		answerHtml,
	};
}

interface FillItinerarySearchDataArgs {
	question: string;
	answer: string;
	lang: AvailableLanguageTag;
}

export function fillItinerarySearchData({
	answer,
	question,
	lang,
}: FillItinerarySearchDataArgs): FAQEntry {
	const answerHtml = replaceText(answer, {
		itinerarySearchUrl: i18nPath('/routes', lang),
		trafficUrl: i18nPath('/map/traffic', lang),
	});

	return {
		question,
		answerHtml,
	};
}
